// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import { CourseType } from '@microsoft/vscodeedu-api';
import React, { HTMLProps } from 'react';
import { FormattedMessage } from 'react-intl';

// Course type label properties.
export type CourseTypeLabelProps = Readonly<
    HTMLProps<HTMLDivElement> & {
        type: CourseType;
    }
>;

// Course type label.
export default (props: CourseTypeLabelProps) => {
    const { type } = props;
    switch (type) {
        case 'coding-activity':
            return (
                <div {...props}>
                    <FormattedMessage defaultMessage="Coding Activity" description="Course type label" />
                </div>
            );
        default:
            return (
                <div {...props}>
                    <FormattedMessage defaultMessage="Course" description="Course type label" />
                </div>
            );
    }
};
